import styled from '@emotion/styled';

const TopNavItemsWrapper = styled.ul<{ $maxWidth?: number }>(
	({ $maxWidth }) => ({
		listStyle: 'none',
		whiteSpace: 'nowrap',
		maxWidth: $maxWidth,
	}),
);

export default TopNavItemsWrapper;
